export const carrierProfileRoutes = [
  {
    slug: 'your-profile',
    name: 'Your Profile',
  },
  {
    slug: 'manage-users',
    name: 'Manage Users',
  },
  {
    slug: 'manage-fleet',
    name: 'Manage Fleet',
  },
];
